import React, {useEffect, useState} from 'react'
import {SetStateAction} from 'react'
import PhoneInput from 'react-phone-input-2'
import {KTSVG} from '../../../../_metronic/helpers'
import {FilterSearchModel, FilterModel} from '../../../types'

type Props = {
  isAdmin: boolean | undefined
  model: FilterModel | undefined
  setModel: React.Dispatch<SetStateAction<FilterModel | undefined>>
}

const FilterButton: React.FC<Props> = ({isAdmin, model, setModel}) => {
  const [display, setDisplay] = useState<boolean>(false)
  const [buttonDisable, setButtonDisable] = useState<boolean>(false)
  const [tempModel, setTempModel] = useState<FilterSearchModel | undefined>()

  // Inputs values
  const [startCreateTime, setStartCreateTime] = useState<string | undefined>()
  const [endCreateTime, setEndCreateTime] = useState<string | undefined>()
  const [startApprovalTime, setStartApprovalTime] = useState<string | undefined>()
  const [endApprovalTime, setEndApprovalTime] = useState<string | undefined>()
  const [requestStatus, setRequestStatus] = useState<any[]>([])

  useEffect(() => {
    setRequestStatus([])
    setStartApprovalTime(undefined)
    setEndApprovalTime(undefined)
    setStartCreateTime(undefined)
    setEndCreateTime(undefined)
  }, [model])

  const handleSearch = () => {
    setButtonDisable(true)
    setTempModel({
      RequestStatus: requestStatus,
      StartCreateDate: startCreateTime,
      EndCreateDate: endCreateTime,
      StartAprrovalDate: startApprovalTime,
      EndAprrovalDate: endApprovalTime
    })
    
    setTimeout(() => {
      setButtonDisable(false)
      setDisplay(false)
    }, 500)
  }

  const handleCheckbox = (value: string) => {
    if(requestStatus){if (requestStatus.indexOf(value) >= 0) {
      let temp = requestStatus
      temp.splice(requestStatus.indexOf(value), 0)
      setRequestStatus(temp)
    } else {
      setRequestStatus([...requestStatus, value])
    }}
  }

  useEffect(() => {
    tempModel && setModel({...model, ...tempModel})
  }, [tempModel])

  return (
    <>
      <div className=' align-items-center ms-1 ms-lg-3'>
        <div
          className='btn btn-icon btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40px '
          id='filter-dropdown'
          data-toggle='dropdown'
          onClick={() => setDisplay(display ? false : true)}
        >
          <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-1' />
        </div>

        {display && (
          <div
            className='card'
            style={{
              display: 'fixed',
              position: 'absolute',
              zIndex: 3,
              right: 10,
              border: '1px solid gray',
              width: 'max-content',
              overflowY: 'auto',
            }}
          >
            <div className='card-body p-6'>
              <form action='submit'>
                <div className='status mt-2'>
                  <h5 className='text-start'>Durum</h5>
                  <div className='d-flex align-items-center' style={{cursor: 'pointer'}}>
                    <input
                      type='checkbox'
                      className='me-1'
                      id='permission-waiting'
                      name='status'
                      value='W'
                      onChange={(e) => handleCheckbox(e.target.value)}
                      defaultChecked={false}
                    />
                    <label htmlFor='permission-waiting'>KVK İzni Bekliyor</label>
                  </div>

                  <div className='d-flex align-items-center' style={{cursor: 'pointer'}}>
                    <input
                      type='checkbox'
                      className='me-1'
                      id='permission-granted'
                      name='status'
                      value='A'
                      onChange={(e) => handleCheckbox(e.target.value)}
                      defaultChecked={false}
                    />
                    <label htmlFor='permission-granted'>KVK İzni Verildi</label>
                  </div>

                  <div className='d-flex align-items-center' style={{cursor: 'pointer'}}>
                    <input
                      type='checkbox'
                      className='me-1'
                      id='new-register'
                      name='status'
                      value='N'
                      onChange={(e) => handleCheckbox(e.target.value)}
                      defaultChecked={false}
                    />
                    <label htmlFor='new-register'>Yeni Kayıt</label>
                  </div>
                </div>

                <div className='permission-date mt-2'>
                  <h5>KVKK Onay Tarihi</h5>
                  <div className='d-flex justify-content-between'>
                    <input
                      className='col-5 btn btn-secondary btn-sm'
                      type='date'
                      name='permission-start-date'
                      id='permission-start-date'
                      onChange={(e) => setStartApprovalTime(e.target.value)}
                      defaultValue={undefined}
                    />
                    <input
                      className='col-5 btn btn-secondary btn-sm'
                      type='date'
                      name='permission-end-date'
                      id='permission-end-date'
                      onChange={(e) => setEndApprovalTime(e.target.value)}
                      defaultValue={undefined}
                    />
                  </div>
                </div>

                <div className='create-date mt-2'>
                  <h5>Oluşturma Tarihi</h5>
                  <div className='d-flex justify-content-between'>
                    <input
                      className='col-5 btn btn-secondary btn-sm'
                      type='date'
                      name='create-start-date'
                      id='create-start-date'
                      onChange={(e) => setStartCreateTime(e.target.value)}
                      defaultValue={undefined}
                    />
                    <input
                      className='col-5 btn btn-secondary btn-sm'
                      type='date'
                      name='create-end-date'
                      id='create-end-date'
                      onChange={(e) => setEndCreateTime(e.target.value)}
                      defaultValue={undefined}
                    />
                  </div>
                </div>

                <hr />

                <div className='filterSubmit d-flex justify-content-center mt-4 w-100'>
                  <button
                    className='btn btn-success w-100'
                    disabled={buttonDisable}
                    onClick={() => handleSearch()}
                  >
                    Ara
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default FilterButton
